import React, { useRef, useEffect, cloneElement } from 'react'
import PropTypes from 'prop-types'
import useEventCallback from '../hooks/useEventCallback'

export default function ClickOutsideListener({
  children,
  mouseEvent = 'click',
  onClickOutside,
  touchEvent = 'touchend',
}) {
  const ref = useRef(null)

  const handleClickOutside = useEventCallback((event) => {
    if (
      ref.current &&
      document.documentElement &&
      document.documentElement.contains(event.target) &&
      !ref.current.contains(event.target)
    ) {
      onClickOutside(event)
    }
  })

  useEffect(() => {
    if (touchEvent !== false) {
      document.addEventListener(touchEvent, handleClickOutside)

      return () => {
        document.removeEventListener(touchEvent, handleClickOutside)
      }
    }
  }, [handleClickOutside, touchEvent])

  useEffect(() => {
    if (mouseEvent !== false) {
      document.addEventListener(mouseEvent, handleClickOutside)

      return () => {
        document.removeEventListener(mouseEvent, handleClickOutside)
      }
    }
  }, [handleClickOutside, mouseEvent])

  return cloneElement(React.Children.only(children), { ref })
}

ClickOutsideListener.propTypes = {
  children: PropTypes.node.isRequired,
  mouseEvent: PropTypes.oneOf(['click', 'mousedown', 'mouseup', 'mouseout', false]),
  onClickOutside: PropTypes.func.isRequired,
  touchEvent: PropTypes.oneOf(['touchend', 'touchstart', false]),
}
